/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 */
import GenericClaimPageWrapper from './GenericClaimPageWrapper';

export default GenericClaimPageWrapper;